import { fetchApi, ADMIN_API } from '@/api/client'
import type { MessageTraceResponse } from '../types/topology'

export interface TraceParams {
  contact:     string
  campaignId?: string
  executionId?: string
  channel:     string
}

export async function traceMessage(params: TraceParams): Promise<MessageTraceResponse> {
  const qs = new URLSearchParams({ contact: params.contact, channel: params.channel })
  if (params.campaignId)  qs.set('campaignId',  params.campaignId)
  if (params.executionId) qs.set('executionId', params.executionId)
  return fetchApi<MessageTraceResponse>(`${ADMIN_API}/pipeline/message-trace?${qs}`)
}
